import { oliveBackgroundTokens } from '@ds/tokens'

const tokens = {
  borderColor: '#cccccc',
  defaultBackgroundColor: oliveBackgroundTokens.bgColorDefault,
} as const

export default tokens
